import React from 'react';
import { List, Datagrid, Filter, ReferenceField, TextField, TextInput } from 'react-admin';

const BlockFilter = (props) => (
  <Filter {...props}>
    <TextInput label="ra.action.search" source="q" alwaysOn />
  </Filter>
);

export const ApartmentList = props => (
  <List filters={<BlockFilter />} {...props} >
    <Datagrid rowClick="edit" >
      <TextField source="id" />
      <TextField source="name" />
      <ReferenceField source="parentId" reference="floors" allowEmpty>
        <TextField source="displayName" />
      </ReferenceField>
    </Datagrid>
</List>
);

export default ApartmentList
